(() => {
  var t,
    e,
    i,
    s,
    a = {
      3: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(619);
        customElements.define(
          "product-slider",
          class extends HTMLElement {
            async connectedCallback() {
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Navigation: e } = await i.e(150).then(i.bind(i, 150));
              t.use([e]);
              const a = this.querySelector("[data-swiper]");
              this.swiper = new t(a, {
                loop: !0,
                navigation: !1,
                slidesPerView: 1,
                breakpoints: { [s.m]: { slidesPerView: 4, spaceBetween: 30 } },
              });
              const n = this.querySelector("[data-swiper-button-next]"),
                r = this.querySelector("[data-swiper-button-prev]");
              n && n.addEventListener("click", () => this.swiper.slideNext()),
                r && r.addEventListener("click", () => this.swiper.slidePrev());
            }
          }
        );
      },
      5: (t, e, i) => {
        var s = {
          "./accordion-component.js": 658,
          "./cart-drawer.js": 190,
          "./cart-line-item-wrapper.js": 759,
          "./cart-line-item.js": 633,
          "./cart-main.js": 814,
          "./collection-tabs.js": 993,
          "./featured-bar-slider.js": 162,
          "./featured-testimonials-slider.js": 793,
          "./filters-drawer.js": 591,
          "./frequently-bought-form.js": 844,
          "./global-component.js": 197,
          "./header.js": 181,
          "./info-card.js": 283,
          "./logo-slider.js": 853,
          "./main-blog.js": 210,
          "./main-collection.js": 82,
          "./modal-component.js": 105,
          "./modal-toggle.js": 484,
          "./price-range.js": 447,
          "./product-card.js": 724,
          "./product-details.js": 262,
          "./product-form.js": 684,
          "./product-media.js": 768,
          "./product-recommendations.js": 836,
          "./product-reviews.js": 33,
          "./product-slider.js": 3,
          "./recommended-articles-slider.js": 347,
          "./search-component.js": 362,
          "./search-overlay.js": 469,
          "./selectable-product-card.js": 801,
          "./social-media-gallery-slider.js": 599,
          "./team-slider.js": 187,
          "./testimonials-slider.js": 112,
          "./upsell-product-card.js": 466,
          "./upsell-slider.js": 799,
          "./video.js": 425,
        };
        function a(t) {
          var e = n(t);
          return i(e);
        }
        function n(t) {
          if (!i.o(s, t)) {
            var e = new Error("Cannot find module '" + t + "'");
            throw ((e.code = "MODULE_NOT_FOUND"), e);
          }
          return s[t];
        }
        (a.keys = function () {
          return Object.keys(s);
        }),
          (a.resolve = n),
          (t.exports = a),
          (a.id = 5);
      },
      33: () => {
        customElements.define(
          "product-reviews",
          class extends HTMLElement {
            constructor() {
              super(),
                (this.buttonSelector = ".jdgm-paginate__load-more"),
                (this.intersectionObserver = null),
                (this.mutationObserver = null);
            }
            connectedCallback() {
              this.observeVisibility();
            }
            disconnectedCallback() {
              this.cleanup();
            }
            observeVisibility() {
              (this.intersectionObserver = new IntersectionObserver(
                (t) => {
                  t.forEach((t) => {
                    t.isIntersecting &&
                      (this.intersectionObserver.disconnect(),
                      this.startTrackingButton());
                  });
                },
                { threshold: 0.1 }
              )),
                this.intersectionObserver.observe(this);
            }
            startTrackingButton() {
              (this.mutationObserver = new MutationObserver(() =>
                this.checkButtonState()
              )),
                this.mutationObserver.observe(document.body, {
                  childList: !0,
                  subtree: !0,
                });
            }
            checkButtonState() {
              document.querySelector(this.buttonSelector) ||
                (this.classList.remove("is-active"), this.cleanup());
            }
            cleanup() {
              this.intersectionObserver &&
                (this.intersectionObserver.disconnect(),
                (this.intersectionObserver = null)),
                this.mutationObserver &&
                  (this.mutationObserver.disconnect(),
                  (this.mutationObserver = null));
            }
          }
        );
      },
      82: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(409);
        customElements.define(
          "main-collection",
          class extends HTMLElement {
            connectedCallback() {
              (this.sectionId = this.dataset.sectionId),
                (this.pageCount = Number(this.dataset.pageCount));
              const t = new URLSearchParams(window.location.search),
                e = parseInt(t.get("page"), 10),
                i = Number.isInteger(e) && e > 0 ? e : 1;
              (this.shouldUpdatePrevBtn = 1 !== i),
                (this.shouldUpdateNextBtn = i !== this.pageCount),
                (this.currentNextPage = i),
                (this.currentPrevPage = i),
                this.initEventListeners();
            }
            initEventListeners() {
              this.setupFilterDrawerToggle(),
                this.setupFilterToggles(),
                this.attachFiltersChangeListener(),
                this.attachLoadButtonListener("[data-load-more-btn]", !0),
                this.attachLoadButtonListener("[data-load-prev-btn]", !1),
                this.attachSortListener(),
                this.attachRemoveFilterListeners(),
                this.attachClearFiltersListener(),
                this.attachGridBannerListeners();
            }
            async fetchSection(t, e = {}) {
              this.classList.add("is-loading");
              const i = new URL(
                t,
                window.location.origin + window.location.pathname
              );
              i.searchParams.set("sections", this.sectionId),
                Object.entries(e).forEach(([t, e]) => i.searchParams.set(t, e));
              const s = await fetch(i.toString());
              if (!s.ok)
                throw (
                  (this.classList.remove("is-loading"),
                  new Error(`Failed fetching: ${s.statusText}`))
                );
              const a = await s.json(),
                n = document.createElement("div");
              return (n.innerHTML = a[this.sectionId]), n;
            }
            replaceAndRebind(t, e = { appendGrid: !1, replaceGrid: !1 }) {
              const i = t.querySelector("[data-product-grid]");
              i && this.updateProductGrid(i, e.appendGrid, e.replaceGrid);
              const s = t.querySelector("[data-filters-container]"),
                a = this.querySelector("[data-filters-container]");
              s && a && a.replaceWith(s);
              const n = t.querySelector("[data-sort-container]"),
                r = this.querySelector("[data-sort-container]");
              n && r && r.replaceWith(n);
              const o = t.querySelector("[data-filters-drawer]"),
                c = this.querySelector("[data-filters-drawer]");
              o && c && c.replaceWith(o);
              const l = t.querySelector("[data-filter-toggle-btn]"),
                d = this.querySelector("[data-filter-toggle-btn]");
              l && d && d.replaceWith(l);
              const h = t.querySelector("[data-active-filters]"),
                u = this.querySelector("[data-active-filters]");
              if ((h && u && u.replaceWith(h), this.shouldUpdateNextBtn))
                this.updateLoadButton(t, "[data-load-more-btn]", !0);
              else {
                const t = this.querySelector("[data-load-more-btn]");
                t?.remove();
              }
              if (this.shouldUpdatePrevBtn)
                this.updateLoadButton(t, "[data-load-prev-btn]", !1);
              else {
                const t = this.querySelector("[data-load-prev-btn]");
                t?.remove();
              }
              this.initEventListeners(),
                this.classList.remove("is-loading"),
                document.body.classList.remove("scroll-lock");
            }
            updateProductGrid(t, e = !1, i = !1) {
              const s = this.querySelector("[data-product-grid]");
              s &&
                t &&
                (i
                  ? s.replaceWith(t)
                  : e
                  ? [...t.children].forEach((t) => s.appendChild(t))
                  : [...t.children].toReversed().forEach((t) => {
                      s.insertBefore(t, s.firstChild);
                    }));
            }
            updateLoadButton(t, e, i) {
              const s = this.querySelector(e),
                a = t.querySelector(e);
              if ((s && s.remove(), a)) {
                const t = this.querySelector("[data-product-grid]");
                i ? t?.after(a) : t?.before(a);
              }
            }
            attachLoadButtonListener(t, e) {
              const i = this.querySelector(t);
              i &&
                i.addEventListener("click", async (t) => {
                  t.preventDefault(),
                    e
                      ? this.currentNextPage++
                      : (this.currentPrevPage--,
                        this.currentPrevPage < 1 && (this.currentPrevPage = 1)),
                    this.currentPrevPage === this.pageCount &&
                      (this.shouldUpdateNextBtn = !1),
                    1 === this.currentPrevPage &&
                      (this.shouldUpdatePrevBtn = !1);
                  const i = e ? this.currentNextPage : this.currentPrevPage,
                    s = new URL(window.location.href),
                    a = new URLSearchParams(s.search);
                  a.set("page", i), (s.search = a.toString());
                  try {
                    const t = await this.fetchSection(s.toString());
                    this.updateUrlParam("page", i),
                      this.replaceAndRebind(t, { appendGrid: e });
                  } catch (t) {
                    console.error("Load button failed:", t);
                  }
                });
            }
            attachSortListener() {
              const t = this.querySelector("[data-sort-by]");
              t &&
                t.addEventListener("change", async (t) => {
                  const e = t.target.value;
                  (this.currentNextPage = 1),
                    (this.currentPrevPage = 1),
                    (this.shouldUpdatePrevBtn = !1),
                    (this.shouldUpdateNextBtn = !0);
                  try {
                    const t = window.location.href,
                      i = await this.fetchSection(t, { sort_by: e, page: 1 });
                    this.updateUrlParam("sort_by", e),
                      this.updateUrlParam("page", 1),
                      this.replaceAndRebind(i, { replaceGrid: !0 }),
                      i
                        .querySelector("[data-product-grid]")
                        ?.scrollIntoView({ behavior: "smooth" });
                  } catch (t) {
                    console.error("Sort change failed:", t);
                  }
                });
            }
            async handleFilterChange() {
              const t = new URLSearchParams(),
                e = new URLSearchParams(window.location.search).get("q");
              e && t.set("q", e);
              const i = (0, s.x)()
                ? '[data-filters] [data-filter-container] input[type="checkbox"][data-filter]'
                : '[data-filters-drawer] [data-filter-container] input[type="checkbox"][data-filter]';
              this.querySelectorAll(i).forEach((e) => {
                e.checked && t.append(e.name, e.value);
              });
              const a = this.querySelector("price-range");
              a &&
                (t.set(a.nameMin, a.rangeMin.value),
                t.set(a.nameMax, a.rangeMax.value));
              const n = this.querySelector("[data-sort-by]")?.value;
              n && t.set("sort_by", n),
                (this.currentNextPage = 1),
                (this.currentPrevPage = 1),
                (this.shouldUpdatePrevBtn = !1),
                (this.shouldUpdateNextBtn = !0),
                t.set("page", 1);
              const r = new URL(window.location.href);
              r.search = t.toString();
              try {
                const t = await this.fetchSection(r.toString());
                window.history.pushState({}, "", r.toString()),
                  this.replaceAndRebind(t, { replaceGrid: !0 });
              } catch (t) {
                console.error("Filter update failed:", t);
              }
            }
            setupFilterToggles() {
              this.querySelectorAll("[data-filter-category]").forEach((t) => {
                t.addEventListener("click", () => {
                  const e = t.getAttribute("data-filter-category"),
                    i = (0, s.x)()
                      ? `[data-filters] [data-filter-container="${e}"]`
                      : `[data-filters-drawer] [data-filter-container="${e}"]`,
                    a = this.querySelector(i);
                  t.classList.toggle("is-active"),
                    a.classList.toggle("is-active");
                });
              });
            }
            attachFiltersChangeListener() {
              this.querySelectorAll("input[data-filter]").forEach((t) => {
                t.addEventListener("change", () => this.handleFilterChange());
              });
            }
            updateUrlParam(t, e) {
              const i = new URL(window.location.href);
              null === e ? i.searchParams.delete(t) : i.searchParams.set(t, e),
                window.history.pushState({}, "", i);
            }
            attachRemoveFilterListeners() {
              this.querySelectorAll("[data-remove-filter]").forEach((t) => {
                t.addEventListener("click", () => {
                  const { param: e } = t.dataset,
                    { value: i } = t.dataset;
                  if (i) {
                    const t = (0, s.x)()
                        ? `[data-filters] [name="${CSS.escape(
                            e
                          )}"][value="${CSS.escape(i)}"]`
                        : `[data-filters-drawer] [name="${CSS.escape(
                            e
                          )}"][value="${CSS.escape(i)}"]`,
                      a = this.querySelector(t);
                    a && (a.checked = !1);
                  } else {
                    const t = (0, s.x)()
                        ? "[data-filters] price-range"
                        : "[data-filters-drawer] price-range",
                      i = this.querySelector(t);
                    if (!i) return;
                    e === i.nameMin &&
                      ((i.rangeMin.value = i.min), (i.inputFrom.value = i.min)),
                      e === i.nameMax &&
                        ((i.rangeMax.value = i.max), (i.inputTo.value = i.max)),
                      i.updateTrack?.();
                  }
                  this.handleFilterChange();
                });
              });
            }
            attachClearFiltersListener() {
              const t = (0, s.x)()
                  ? "[data-filters] [data-clear-filters]"
                  : "[data-filters-drawer] [data-clear-filters]",
                e = this.querySelector(t);
              e &&
                e.addEventListener("click", () => {
                  const t = (0, s.x)()
                    ? '[data-filters] [data-filter-container] input[type="checkbox"][data-filter]'
                    : '[data-filters-drawer] [data-filter-container] input[type="checkbox"][data-filter]';
                  this.querySelectorAll(t).forEach((t) => (t.checked = !1));
                  const e = this.querySelector("price-range");
                  e && e.reset(), this.handleFilterChange();
                });
            }
            attachGridBannerListeners() {
              const t = this.querySelectorAll("[data-open-calendly]"),
                e = this.querySelectorAll("[data-open-chat]");
              t.forEach((t) => {
                t.addEventListener("click", async (t) => {
                  if ((t.preventDefault(), !window.Calendly)) {
                    if (!document.querySelector("#calendly-widget-css")) {
                      const t = document.createElement("link");
                      (t.id = "calendly-widget-css"),
                        (t.rel = "stylesheet"),
                        (t.href =
                          "https://assets.calendly.com/assets/external/widget.css"),
                        document.head.appendChild(t);
                    }
                    await new Promise((t) => {
                      if (document.querySelector("#calendly-widget-js"))
                        return t();
                      const e = document.createElement("script");
                      (e.id = "calendly-widget-js"),
                        (e.src =
                          "https://assets.calendly.com/assets/external/widget.js"),
                        (e.async = !0),
                        (e.onload = t),
                        document.head.appendChild(e);
                    });
                  }
                  window.Calendly &&
                    window.Calendly.initPopupWidget({
                      url: "https://calendly.com/golfbays-consultation/consultation",
                    });
                });
              }),
                e.forEach((t) =>
                  t.addEventListener("click", () => {
                    window.Tawk_API &&
                      "function" == typeof window.Tawk_API.maximize &&
                      window.Tawk_API.maximize();
                  })
                );
            }
            setupFilterDrawerToggle() {
              this.querySelectorAll("[data-filter-toggle-btn]").forEach((t) => {
                t.addEventListener("click", () => {
                  window.dispatchEvent(
                    new CustomEvent("filters-drawer:toggle")
                  );
                });
              });
            }
          }
        );
      },
      105: () => {
        customElements.define(
          "modal-component",
          class extends HTMLElement {
            connectedCallback() {
              (this.type = this.dataset.type),
                (this.overlay = this.querySelector("[data-overlay]")),
                (this.content = this.querySelector("[data-modal-content]")),
                (this.closeButton = this.querySelector("[data-close]")),
                window.addEventListener("modal-toggle", (t) => {
                  t.detail.type === this.type && this.toggleModal();
                }),
                this.overlay?.addEventListener("click", () =>
                  this.closeModal()
                ),
                this.closeButton?.addEventListener("click", () =>
                  this.closeModal()
                );
            }
            openModal() {
              this.classList.add("is-active"),
                document.body.classList.add("scroll-lock"),
                requestAnimationFrame(() => {
                  this.classList.add("is-visible");
                });
            }
            closeModal() {
              this.classList.remove("is-visible"),
                setTimeout(() => {
                  this.classList.remove("is-active"),
                    document.body.classList.remove("scroll-lock");
                }, 300);
            }
            toggleModal() {
              this.classList.contains("is-active")
                ? this.closeModal()
                : this.openModal();
            }
          }
        );
      },
      112: (t, e, i) => {
        customElements.define(
          "testimonials-slider",
          class extends HTMLElement {
            async connectedCallback() {
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Navigation: e, Pagination: s } = await i
                  .e(150)
                  .then(i.bind(i, 150));
              t.use([e, s]);
              const a = this.querySelector("[data-swiper]"),
                n = this.querySelectorAll("[data-swiper-slide]");
              this.swiper = new t(a, {
                loop: !0,
                navigation: !1,
                initialSlide: Math.floor((n.length - 1) / 2),
                pagination: {
                  el: "[data-swiper-pagination]",
                  dynamicBullets: !0,
                  bulletElement: "button",
                  bulletClass: "slider-bullet",
                  bulletActiveClass: "slider-bullet-active",
                },
              });
              const r = this.querySelector("[data-swiper-button-next]"),
                o = this.querySelector("[data-swiper-button-prev]");
              r && r.addEventListener("click", () => this.swiper.slideNext()),
                o && o.addEventListener("click", () => this.swiper.slidePrev());
            }
          }
        );
      },
      162: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(409);
        customElements.define(
          "featured-bar-slider",
          class extends HTMLElement {
            async connectedCallback() {
              if ((0, s.x)()) return;
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Autoplay: e } = await i.e(150).then(i.bind(i, 150));
              t.use([e]),
                (this.swiper = new t(this, {
                  loop: !0,
                  slidesPerView: "auto",
                  centeredSlides: !0,
                  allowTouchMove: !1,
                  ...(Object.prototype.hasOwnProperty.call(
                    this.dataset,
                    "highlightActiveFeature"
                  )
                    ? { slideActiveClass: "featured-bar-slide-active" }
                    : {}),
                  autoplay: { delay: 1e3 * this.dataset.sliderSpeed },
                  on: {
                    init: () => {
                      this.classList.remove("is-loading");
                    },
                  },
                }));
            }
          }
        );
      },
      181: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(619),
          a = i(409);
        customElements.define(
          "header-component",
          class extends HTMLElement {
            constructor() {
              super(),
                (this._lastScrollY = window.scrollY),
                (this._ticking = !1),
                (this._threshold = 0),
                (this._onScroll = this._onScroll.bind(this)),
                (this._onMenuToggleClick = this._onMenuToggleClick.bind(this)),
                (this._onCartToggleClick = this._onCartToggleClick.bind(this)),
                (this._onUpdateCartItemsCount =
                  this._onUpdateCartItemsCount.bind(this));
            }
            connectedCallback() {
              const t = getComputedStyle(document.documentElement)
                  .getPropertyValue("--header-height")
                  .trim(),
                e = parseFloat(t);
              (this._threshold = Number.isNaN(e) ? 50 : e * s.A),
                window.addEventListener("scroll", this._onScroll, {
                  passive: !0,
                }),
                (this._menuBtn = this.querySelector("[data-header-menu-btn]")),
                (this._menuMobile = this.querySelector(
                  "[data-header-menu-mobile]"
                )),
                this._menuBtn &&
                  this._menuMobile &&
                  this._menuBtn.addEventListener(
                    "click",
                    this._onMenuToggleClick
                  ),
                this.querySelectorAll("[data-menu-item]").forEach((t) => {
                  (0, a.x)()
                    ? (t.addEventListener("mouseenter", () =>
                        this._onMenuItemHover(t)
                      ),
                      t.addEventListener("mouseleave", () =>
                        this._onMenuItemLeave(t)
                      ))
                    : t.addEventListener("click", () =>
                        this._onMenuItemClick(t)
                      );
                }),
                (this._cartToggleBtnList = this.querySelectorAll(
                  "[data-cart-drawer-toggle]"
                )),
                this._cartToggleBtnList.length &&
                  this._cartToggleBtnList.forEach((t) =>
                    t.addEventListener("click", this._onCartToggleClick)
                  ),
                (this.cartCountElems =
                  Array.from(this.querySelectorAll("[data-cart-count]")) || []),
                window.addEventListener(
                  "cart-items-count:update",
                  this._onUpdateCartItemsCount
                );
            }
            disconnectedCallback() {
              window.removeEventListener("scroll", this._onScroll),
                this._menuBtn &&
                  this._menuBtn.removeEventListener(
                    "click",
                    this._onMenuToggleClick
                  ),
                this._cartToggleBtnList.length &&
                  this._cartToggleBtnList.forEach((t) =>
                    t.removeEventListener("click", this._onCartToggleClick)
                  ),
                window.removeEventListener(
                  "cart-items-count:update",
                  this._onUpdateCartItemsCount
                );
            }
            _onScroll() {
              this._ticking ||
                ((this._ticking = !0),
                window.requestAnimationFrame(() => {
                  const t = window.scrollY,
                    e = t > this._lastScrollY,
                    i = Math.abs(t - this._lastScrollY);
                  e && i >= this._threshold
                    ? this.classList.add("is-hidden")
                    : e || this.classList.remove("is-hidden"),
                    (this._lastScrollY = t),
                    (this._ticking = !1);
                }));
            }
            _onMenuToggleClick() {
              const t = this._menuMobile.classList.contains("is-active");
              this.querySelectorAll("[data-menu-item]").forEach((t) =>
                t.classList.remove("is-active")
              ),
                this.querySelectorAll("[data-menu-container]").forEach((t) =>
                  t.classList.remove("is-active-mobile")
                ),
                this._menuMobile.classList.toggle("is-active", !t),
                document.body.classList.toggle("is-locked", !t);
            }
            _onMenuItemClick(t) {
              const e = t.closest("[data-menu-container]"),
                i = e.querySelectorAll("[data-menu-item]"),
                s = t.classList.contains("is-active");
              i.forEach((t) => t.classList.remove("is-active")),
                s || t.classList.add("is-active");
              const a = Array.from(i).some((t) =>
                t.classList.contains("is-active")
              );
              e.classList.toggle("is-active-mobile", a);
            }
            _onMenuItemHover(t) {
              const e = t.closest("[data-menu-container]"),
                i = e.querySelectorAll("[data-menu-item]"),
                s = Array.from(i).find((t) =>
                  t.classList.contains("is-active")
                );
              s !== t &&
                (s && s.classList.remove("is-active"),
                t.classList.add("is-active"),
                e.classList.add("is-active"));
            }
            _onMenuItemLeave(t) {
              const e = t.closest("[data-menu-container]");
              t.classList.remove("is-active");
              const i = Array.from(e.querySelectorAll("[data-menu-item]")).some(
                (t) => t.classList.contains("is-active")
              );
              e.classList.toggle("is-active", i);
            }
            _onCartToggleClick() {
              const t = new CustomEvent("cart-drawer:toggle");
              window.dispatchEvent(t);
            }
            _onUpdateCartItemsCount(t) {
              const e = t?.detail?.quantity || 0;
              this.cartCountElems.forEach((t) => {
                t.textContent = e > 0 ? e : "";
              });
            }
          }
        );
      },
      187: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(409);
        customElements.define(
          "team-slider",
          class extends HTMLElement {
            async connectedCallback() {
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Navigation: e } = await i.e(150).then(i.bind(i, 150));
              t.use([e]);
              const a = this.querySelector("[data-swiper]"),
                n = this.querySelector("[data-swiper-wrapper]");
              let r = this.querySelectorAll("[data-swiper-slide]"),
                o = r.length;
              if (o > 0) {
                const t = (0, s.x)() ? 8 : 2;
                if (o < t) {
                  const e = t - o,
                    i = Array.from(r),
                    s = document.createDocumentFragment();
                  for (let t = 0; t < e; t++) {
                    const e = i[t % o].cloneNode(!0);
                    s.appendChild(e);
                  }
                  n.appendChild(s),
                    (r = this.querySelectorAll("[data-swiper-slide]")),
                    (o = r.length);
                }
              }
              this.swiper = new t(a, {
                loop: !0,
                navigation: !1,
                breakpoints: {
                  1024: {
                    watchSlidesProgress: !0,
                    slidesPerView: 4,
                    spaceBetween: 28,
                    centeredSlides: !0,
                    slideFullyVisibleClass: "is-visible",
                  },
                },
              });
              const c = this.querySelector("[data-swiper-button-next]"),
                l = this.querySelector("[data-swiper-button-prev]");
              o <= 1 || ((0, s.x)() && o < 5)
                ? (c?.remove(), l?.remove())
                : (c?.addEventListener("click", () => this.swiper.slideNext()),
                  l?.addEventListener("click", () => this.swiper.slidePrev()));
            }
          }
        );
      },
      190: () => {
        customElements.define(
          "cart-drawer",
          class extends HTMLElement {
            connectedCallback() {
              (this.overlay = this.querySelector("[data-overlay]")),
                (this.closeBtn = this.querySelector("[data-close-btn]")),
                this._bindEvents();
            }
            disconnectedCallback() {
              this._unbindEvents();
            }
            _bindEvents() {
              (this._onToggle = this._onToggle.bind(this)),
                (this._onOverlayClick = this._onOverlayClick.bind(this)),
                (this._onEscKey = this._onEscKey.bind(this)),
                window.addEventListener("cart-drawer:toggle", this._onToggle),
                document.addEventListener("keydown", this._onEscKey),
                this.overlay?.addEventListener("click", this._onOverlayClick),
                this.closeBtn?.addEventListener("click", () => this.close());
            }
            _unbindEvents() {
              window.removeEventListener("cart-drawer:toggle", this._onToggle),
                document.removeEventListener("keydown", this._onEscKey),
                this.overlay?.removeEventListener(
                  "click",
                  this._onOverlayClick
                ),
                this.closeBtn?.removeEventListener("click", () => this.close());
            }
            _onToggle() {
              this.parentElement.classList.toggle("is-active"),
                document.body.classList.toggle("scroll-lock");
            }
            _onOverlayClick() {
              this.close();
            }
            _onEscKey(t) {
              "Escape" === t.key && this.close();
            }
            open() {
              this.parentElement.classList.add("is-active"),
                document.body.classList.add("scroll-lock");
            }
            close() {
              this.parentElement.classList.remove("is-active"),
                document.body.classList.remove("scroll-lock");
            }
          }
        );
      },
      197: () => {
        customElements.define(
          "global-component",
          class extends HTMLElement {
            connectedCallback() {
              const t =
                window.innerWidth - document.documentElement.clientWidth;
              document.documentElement.style.setProperty(
                "--scrollbar-width",
                `${t}px`
              );
            }
          }
        );
      },
      210: () => {
        customElements.define(
          "main-blog",
          class extends HTMLElement {
            connectedCallback() {
              const t = this.querySelector("[data-sort-by]");
              t &&
                t.addEventListener("change", (t) => {
                  const e = t.target.value;
                  e && (window.location.href = e);
                });
            }
          }
        );
      },
      262: () => {
        customElements.define(
          "product-details",
          class extends HTMLElement {
            constructor() {
              super(), (this._cache = new Map());
            }
            connectedCallback() {
              (this.sectionId = this.dataset.sectionId),
                (this._onVariantChange = this._onVariantChange.bind(this)),
                this.addEventListener("variant:change", this._onVariantChange);
            }
            disconnectedCallback() {
              this.removeEventListener("variant:change", this._onVariantChange);
            }
            async _onVariantChange(t) {
              const { variant: e } = t.detail;
              if (!e) return;
              const i = e.id;
              let s;
              if (this._cache.has(i)) s = this._cache.get(i).cloneNode(!0);
              else {
                const t = `${window.location.pathname}?section_id=${this.sectionId}&variant=${i}`;
                try {
                  const e = await fetch(t),
                    a = await e.text(),
                    n = new DOMParser()
                      .parseFromString(a, "text/html")
                      .querySelector("[data-product-price]");
                  if (!n) return;
                  this._cache.set(i, n.cloneNode(!0)), (s = n);
                } catch (t) {
                  return void console.error("Failed to fetch price:", t);
                }
              }
              const a = this.querySelector("[data-product-price]");
              s && a && a.replaceWith(s);
            }
          }
        );
      },
      283: () => {
        customElements.define(
          "info-card",
          class extends HTMLElement {
            connectedCallback() {
              const t = this.querySelector("[data-text]"),
                e = this.querySelector("[data-read-more]"),
                i = this.querySelector("[data-read-less]");
              (() => {
                const { height: i } = t.getBoundingClientRect();
                t.scrollHeight > Math.ceil(i) || e?.remove();
              })(),
                e?.addEventListener("click", () => {
                  t.classList.add("is-active"),
                    e.classList.remove("is-active"),
                    i.classList.add("is-active");
                }),
                i?.addEventListener("click", () => {
                  t.classList.remove("is-active"),
                    i.classList.remove("is-active"),
                    e.classList.add("is-active");
                });
            }
          }
        );
      },
      322: (t, e, i) => {
        var s = {
          "./accordion-component": [658, 9],
          "./accordion-component.js": [658, 9],
          "./cart-drawer": [190, 7],
          "./cart-drawer.js": [190, 7],
          "./cart-line-item": [633, 7],
          "./cart-line-item-wrapper": [759, 7],
          "./cart-line-item-wrapper.js": [759, 7],
          "./cart-line-item.js": [633, 7],
          "./cart-main": [814, 7],
          "./cart-main.js": [814, 7],
          "./collection-tabs": [993, 7],
          "./collection-tabs.js": [993, 7],
          "./featured-bar-slider": [162, 9],
          "./featured-bar-slider.js": [162, 9],
          "./featured-testimonials-slider": [793, 9],
          "./featured-testimonials-slider.js": [793, 9],
          "./filters-drawer": [591, 7],
          "./filters-drawer.js": [591, 7],
          "./frequently-bought-form": [844, 9],
          "./frequently-bought-form.js": [844, 9],
          "./global-component": [197, 7],
          "./global-component.js": [197, 7],
          "./header": [181, 9],
          "./header.js": [181, 9],
          "./info-card": [283, 7],
          "./info-card.js": [283, 7],
          "./logo-slider": [853, 7],
          "./logo-slider.js": [853, 7],
          "./main-blog": [210, 7],
          "./main-blog.js": [210, 7],
          "./main-collection": [82, 9],
          "./main-collection.js": [82, 9],
          "./modal-component": [105, 7],
          "./modal-component.js": [105, 7],
          "./modal-toggle": [484, 7],
          "./modal-toggle.js": [484, 7],
          "./price-range": [447, 7],
          "./price-range.js": [447, 7],
          "./product-card": [724, 9],
          "./product-card.js": [724, 9],
          "./product-details": [262, 7],
          "./product-details.js": [262, 7],
          "./product-form": [684, 9],
          "./product-form.js": [684, 9],
          "./product-media": [768, 9],
          "./product-media.js": [768, 9],
          "./product-recommendations": [836, 9],
          "./product-recommendations.js": [836, 9],
          "./product-reviews": [33, 7],
          "./product-reviews.js": [33, 7],
          "./product-slider": [3, 9],
          "./product-slider.js": [3, 9],
          "./recommended-articles-slider": [347, 9],
          "./recommended-articles-slider.js": [347, 9],
          "./search-component": [362, 9],
          "./search-component.js": [362, 9],
          "./search-overlay": [469, 7],
          "./search-overlay.js": [469, 7],
          "./selectable-product-card": [801, 7],
          "./selectable-product-card.js": [801, 7],
          "./social-media-gallery-slider": [599, 9],
          "./social-media-gallery-slider.js": [599, 9],
          "./team-slider": [187, 9],
          "./team-slider.js": [187, 9],
          "./testimonials-slider": [112, 7],
          "./testimonials-slider.js": [112, 7],
          "./upsell-product-card": [466, 7],
          "./upsell-product-card.js": [466, 7],
          "./upsell-slider": [799, 7],
          "./upsell-slider.js": [799, 7],
          "./video": [425, 7],
          "./video.js": [425, 7],
        };
        function a(t) {
          return Promise.resolve().then(() => {
            if (!i.o(s, t)) {
              var e = new Error("Cannot find module '" + t + "'");
              throw ((e.code = "MODULE_NOT_FOUND"), e);
            }
            var a = s[t],
              n = a[0];
            return i.t(n, 16 | a[1]);
          });
        }
        (a.keys = () => Object.keys(s)), (a.id = 322), (t.exports = a);
      },
      347: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(619);
        customElements.define(
          "recommended-articles-slider",
          class extends HTMLElement {
            async connectedCallback() {
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Navigation: e } = await i.e(150).then(i.bind(i, 150));
              t.use([e]);
              const a = this.querySelector("[data-swiper]");
              this.swiper = new t(a, {
                loop: !0,
                navigation: !1,
                slidesPerView: 1,
                breakpoints: { [s.m]: { slidesPerView: 3, spaceBetween: 30 } },
              });
              const n = this.querySelector("[data-swiper-button-next]"),
                r = this.querySelector("[data-swiper-button-prev]");
              n && n.addEventListener("click", () => this.swiper.slideNext()),
                r && r.addEventListener("click", () => this.swiper.slidePrev());
            }
          }
        );
      },
      362: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(735);
        customElements.define(
          "search-component",
          class extends HTMLElement {
            connectedCallback() {
              (this.searchInput = this.querySelector("[data-search-input]")),
                (this.mainContainer = this.querySelector(
                  "[data-main-container]"
                )),
                (this.emptyContainer = this.querySelector(
                  "[data-empty-container]"
                )),
                (this.initialContainer = this.querySelector(
                  "[data-initial-container]"
                )),
                (this.productGridContainer = this.querySelector(
                  "[data-product-grid-container]"
                )),
                this._bindEvents();
            }
            _bindEvents() {
              this.searchInput.addEventListener("input", (t) => {
                t.target.value || this._resetState();
              }),
                this.searchInput.addEventListener(
                  "input",
                  (0, s.s)(async (t) => {
                    if (!t.target.value) return;
                    this.classList.add("is-loading");
                    const e = this._getSearchParams(t.target.value),
                      i = `${window.location.pathname}?${e}`;
                    try {
                      const t = await this._fetchSearchResults(i);
                      this._replaceMainContainer(t),
                        window.history.pushState({}, "", i);
                    } catch (t) {
                      console.error("Search load failed:", t);
                    } finally {
                      this.classList.remove("is-loading");
                    }
                  }, 300)
                );
            }
            async _fetchSearchResults(t) {
              const e = await fetch(t, {
                headers: { "X-Requested-With": "XMLHttpRequest" },
              });
              if (!e.ok) throw new Error(`HTTP ${e.status}`);
              const i = await e.text();
              return new DOMParser()
                .parseFromString(i, "text/html")
                .querySelector("[data-main-container]");
            }
            _replaceMainContainer(t) {
              t &&
                ((this.mainContainer.innerHTML = t.innerHTML),
                (this.emptyContainer = this.mainContainer.querySelector(
                  "[data-empty-container]"
                )),
                (this.initialContainer = this.mainContainer.querySelector(
                  "[data-initial-container]"
                )),
                (this.productGridContainer = this.mainContainer.querySelector(
                  "[data-product-grid-container]"
                )));
            }
            _resetState() {
              this.emptyContainer?.classList.remove("is-active"),
                this.initialContainer?.classList.add("is-active"),
                (this.productGridContainer.innerHTML = "");
              const t = window.location.pathname;
              window.history.pushState({}, "", t);
            }
            _getSearchParams(t) {
              const e = new URLSearchParams();
              return e.set("q", t), e.set("type", "product"), e.toString();
            }
          }
        );
      },
      409: (t, e, i) => {
        "use strict";
        i.d(e, { x: () => s });
        const s = () => window.matchMedia("(min-width: 64rem)").matches;
      },
      425: () => {
        customElements.define(
          "video-component",
          class extends HTMLElement {
            connectedCallback() {
              (this.video = this.querySelector("video")),
                (this.iframe = this.querySelector("iframe")),
                (this.sources =
                  this.video?.querySelectorAll("source[data-src]")),
                (this.posterImage = this.querySelector("[data-poster]")),
                (this.hasLoadedSources = !1),
                this.addEventListener("click", () => this.toggleVideo(), {
                  once: !0,
                }),
                this.iframe &&
                  (this.iframe.src.includes("youtube.com") ||
                  this.iframe.src.includes("youtu.be") ||
                  this.iframe.src.includes("youtube-nocookie")
                    ? this.setupYouTubeAPI()
                    : this.iframe.src.includes("vimeo.com") &&
                      this.setupVimeoAPI());
            }
            setupYouTubeAPI() {
              if (window.YT && window.YT.Player) this.createYouTubePlayer();
              else {
                const t = document.createElement("script");
                (t.src = "https://www.youtube.com/iframe_api"),
                  document.body.appendChild(t),
                  (window.onYouTubeIframeAPIReady = () =>
                    this.createYouTubePlayer());
              }
            }
            createYouTubePlayer() {
              (this.player = new window.YT.Player(this.iframe, {
                events: {
                  onReady: () => {
                    this.isReady = !0;
                  },
                },
              })),
                (this.isYouTube = !0);
            }
            setupVimeoAPI() {
              if (window.Vimeo) this.createVimeoPlayer();
              else {
                const t = document.createElement("script");
                (t.src = "https://player.vimeo.com/api/player.js"),
                  document.body.appendChild(t),
                  (t.onload = () => this.createVimeoPlayer());
              }
            }
            createVimeoPlayer() {
              (this.player = new window.Vimeo.Player(this.iframe)),
                (this.isReady = !0),
                (this.isVimeo = !0);
            }
            loadSources() {
              !this.hasLoadedSources &&
                this.sources?.length &&
                (this.sources.forEach((t) => {
                  t.setAttribute("src", t.getAttribute("data-src")),
                    t.removeAttribute("data-src");
                }),
                this.video.load(),
                (this.hasLoadedSources = !0));
            }
            async toggleVideo() {
              if (this.iframe && this.player && this.isReady)
                return (
                  this.removePoster(),
                  void (this.isYouTube
                    ? this.player.playVideo()
                    : this.isVimeo && this.player.play())
                );
              if (this.video) {
                if (
                  (this.hasLoadedSources || this.loadSources(),
                  this.video.paused)
                )
                  try {
                    (this.video.controls = !0), await this.video.play();
                  } catch (t) {
                    console.error("Video failed to play:", t);
                  }
                this.removePoster();
              }
            }
            removePoster() {
              this.posterImage && this.posterImage.classList.add("is-hidden");
            }
          }
        );
      },
      447: () => {
        customElements.define(
          "price-range",
          class extends HTMLElement {
            connectedCallback() {
              (this.min = parseFloat(this.dataset.min)),
                (this.max = parseFloat(this.dataset.max)),
                (this.nameMin = this.dataset.minName),
                (this.nameMax = this.dataset.maxName),
                (this.priceGap = 0.05 * (this.max - this.min)),
                (this.rangeMin = this.querySelector("[data-range-min]")),
                (this.rangeMax = this.querySelector("[data-range-max]")),
                (this.track = this.querySelector("[data-range-track]")),
                (this.inputFrom = this.querySelector(
                  "[data-price-input-from]"
                )),
                (this.inputTo = this.querySelector("[data-price-input-to]")),
                (this.from = parseFloat(this.dataset.from) || this.min),
                (this.to = parseFloat(this.dataset.to) || this.max),
                this.initInputs(),
                this.attachEvents(),
                this.updateTrack();
            }
            initInputs() {
              (this.rangeMin.min = this.min),
                (this.rangeMin.max = this.max),
                (this.rangeMax.min = this.min),
                (this.rangeMax.max = this.max),
                (this.rangeMin.step = 1),
                (this.rangeMax.step = 1),
                (this.rangeMin.value = this.from),
                (this.rangeMax.value = this.to),
                (this.inputFrom.min = this.min),
                (this.inputFrom.max = this.max),
                (this.inputTo.min = this.min),
                (this.inputTo.max = this.max),
                (this.inputFrom.value = this.from),
                (this.inputTo.value = this.to);
            }
            attachEvents() {
              this.inputFrom.addEventListener("input", () => {
                let t = parseFloat(this.inputFrom.value);
                Number.isNaN(t) && (t = this.min),
                  (t = Math.max(t, this.min)),
                  (t = Math.min(t, this.rangeMax.value - this.priceGap)),
                  (this.inputFrom.value = t),
                  (this.rangeMin.value = t),
                  this.updateTrack(),
                  this.dispatchChange();
              }),
                this.inputTo.addEventListener("input", () => {
                  let t = parseFloat(this.inputTo.value);
                  Number.isNaN(t) && (t = this.max),
                    (t = Math.min(t, this.max)),
                    (t = Math.max(
                      t,
                      this.rangeMin.valueAsNumber + this.priceGap
                    )),
                    (this.inputTo.value = t),
                    (this.rangeMax.value = t),
                    this.updateTrack(),
                    this.dispatchChange();
                }),
                this.rangeMin.addEventListener("input", () => {
                  let t = parseFloat(this.rangeMin.value);
                  t > this.rangeMax.value - this.priceGap &&
                    ((t = this.rangeMax.value - this.priceGap),
                    (this.rangeMin.value = t)),
                    (this.inputFrom.value = t),
                    this.updateTrack();
                }),
                this.rangeMin.addEventListener("change", () => {
                  this.dispatchChange();
                }),
                this.rangeMax.addEventListener("input", () => {
                  let t = parseFloat(this.rangeMax.value);
                  t < this.rangeMin.valueAsNumber + this.priceGap &&
                    ((t = this.rangeMin.valueAsNumber + this.priceGap),
                    (this.rangeMax.value = t)),
                    (this.inputTo.value = t),
                    this.updateTrack();
                }),
                this.rangeMax.addEventListener("change", () => {
                  this.dispatchChange();
                });
            }
            dispatchChange() {
              const t = this.closest("main-collection");
              t?.handleFilterChange();
            }
            updateTrack() {
              const t = parseFloat(this.rangeMin.value),
                e = parseFloat(this.rangeMax.value),
                i = ((t - this.min) / (this.max - this.min)) * 100,
                s = ((e - this.min) / (this.max - this.min)) * 100;
              (this.track.style.left = `${i}%`),
                (this.track.style.right = 100 - s + "%");
            }
            reset() {
              (this.rangeMin.value = this.min),
                (this.rangeMax.value = this.max),
                (this.inputFrom.value = this.min),
                (this.inputTo.value = this.max),
                this.updateTrack(),
                this.dispatchChange();
            }
          }
        );
      },
      466: () => {
        customElements.define(
          "upsell-product-card",
          class extends HTMLElement {
            connectedCallback() {
              (this.submitBtn = this.querySelector("[data-submit-btn]")),
                (this.variantId = this.dataset.variantId),
                this.submitBtn &&
                  this.variantId &&
                  ((this._onAddToCart = this._onAddToCart.bind(this)),
                  this.submitBtn.addEventListener("click", this._onAddToCart));
            }
            disconnectedCallback() {
              this.submitBtn &&
                this.submitBtn.removeEventListener("click", this._onAddToCart);
            }
            async _onAddToCart(t) {
              if ((t.preventDefault(), !this.variantId)) return;
              this.classList.add("is-loading"), (this.submitBtn.disabled = !0);
              const e = { id: Number(this.variantId), quantity: 1 };
              window.dispatchEvent(
                new CustomEvent("cart:add-items", {
                  detail: {
                    items: [e],
                    successCallback: () => {
                      (this.submitBtn.disabled = !1),
                        this.classList.remove("is-loading");
                    },
                  },
                })
              );
            }
          }
        );
      },
      469: () => {
        customElements.define(
          "search-overlay",
          class extends HTMLElement {
            constructor() {
              super(), (this._debounceTimer = null);
            }
            connectedCallback() {
              (this.input = this.querySelector("[data-search-input]")),
                (this.content = this.querySelector("[data-search-content]")),
                (this.emptyContainer = this.querySelector(
                  "[data-empty-container]"
                )),
                (this.resultsContainer = this.querySelector(
                  "[data-results-container]"
                )),
                (this.initialContainer = this.querySelector(
                  "[data-initial-container]"
                )),
                (this.sectionId = this.dataset.sectionId),
                this.input.addEventListener("input", (t) => {
                  clearTimeout(this._debounceTimer),
                    (this._debounceTimer = setTimeout(() => {
                      "Enter" !== t.key && this._handleInput();
                    }, 300));
                }),
                this.input.addEventListener("keypress", (t) => {
                  if ("Enter" === t.key && this.input.value.trim().length) {
                    const t = new URLSearchParams({
                      q: this.input.value.trim(),
                    });
                    window.location.href = `${
                      window.Shoppy.routes.search
                    }?${t.toString()}`;
                  }
                }),
                window.addEventListener("modal-toggle", (t) =>
                  this._onModalToggle(t.detail.type)
                );
            }
            _initTabs() {
              const t = this.content.querySelectorAll("[data-results-tab]"),
                e = this.content.querySelectorAll("[data-results-panel]");
              t.forEach((i) => {
                i.addEventListener("click", () => {
                  t.forEach((t) => t.classList.remove("is-active")),
                    e.forEach((t) => t.classList.add("hidden")),
                    i.classList.add("is-active");
                  const s = i.getAttribute("data-results-tab"),
                    a = this.content.querySelector(
                      `[data-results-panel="${s}"]`
                    );
                  a && a.classList.remove("hidden");
                });
              });
            }
            async _getResults() {
              const t = this.input.value.trim().replace(/\s+/g, " ");
              if (/[a-z0-9]/i.test(t)) {
                this.classList.add("is-loading");
                try {
                  const e = `${
                      window.Shoppy.routes.predictiveSearch
                    }?q=${encodeURIComponent(t)}&section_id=${
                      this.sectionId
                    }&resources[type]=product,collection&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,tag`,
                    i = await fetch(e),
                    s = await i.text(),
                    a = document.createElement("div");
                  a.innerHTML = s;
                  const n = a.querySelector("[data-search-content]");
                  n &&
                    ((this.content.innerHTML = n.innerHTML),
                    this._initTabs(),
                    (this.emptyContainer = this.querySelector(
                      "[data-empty-container]"
                    )),
                    (this.resultsContainer = this.querySelector(
                      "[data-results-container]"
                    )),
                    (this.initialContainer = this.querySelector(
                      "[data-initial-container]"
                    )));
                } catch (t) {
                  console.error(t);
                } finally {
                  this.classList.remove("is-loading");
                }
              }
            }
            _resetSearch() {
              this.emptyContainer?.classList.remove("is-active"),
                this.resultsContainer?.classList.remove("is-active"),
                this.initialContainer?.classList.add("is-active");
            }
            _handleInput() {
              0 === this.input.value.length
                ? this._resetSearch()
                : this._getResults();
            }
            _onModalToggle(t) {
              "search-overlay" === t &&
                (this.classList.contains("is-open")
                  ? (this.classList.remove("is-open"),
                    setTimeout(() => {
                      (this.input.value = ""), this._resetSearch();
                    }, 300))
                  : (this.classList.add("is-open"),
                    setTimeout(() => this.input.focus(), 100)));
            }
          }
        );
      },
      484: () => {
        customElements.define(
          "modal-toggle",
          class extends HTMLElement {
            connectedCallback() {
              this.addEventListener("click", () => {
                const { type: t } = this.dataset;
                t &&
                  window.dispatchEvent(
                    new CustomEvent("modal-toggle", { detail: { type: t } })
                  );
              });
            }
          }
        );
      },
      591: () => {
        customElements.define(
          "filters-drawer",
          class extends HTMLElement {
            connectedCallback() {
              (this.overlay = this.querySelector("[data-overlay]")),
                (this.closeBtn = this.querySelector("[data-close-btn]")),
                this._bindEvents();
            }
            disconnectedCallback() {
              this._unbindEvents();
            }
            _bindEvents() {
              (this._onToggle = this._onToggle.bind(this)),
                (this._onOverlayClick = this._onOverlayClick.bind(this)),
                (this._onEscKey = this._onEscKey.bind(this)),
                window.addEventListener(
                  "filters-drawer:toggle",
                  this._onToggle
                ),
                document.addEventListener("keydown", this._onEscKey),
                this.overlay?.addEventListener("click", this._onOverlayClick),
                this.closeBtn?.addEventListener("click", () => this.close());
            }
            _unbindEvents() {
              window.removeEventListener(
                "filters-drawer:toggle",
                this._onToggle
              ),
                document.removeEventListener("keydown", this._onEscKey),
                this.overlay?.removeEventListener(
                  "click",
                  this._onOverlayClick
                ),
                this.closeBtn?.removeEventListener("click", () => this.close());
            }
            _onToggle() {
              this.classList.toggle("is-active"),
                document.body.classList.toggle("scroll-lock");
            }
            _onOverlayClick() {
              this.close();
            }
            _onEscKey(t) {
              "Escape" === t.key && this.close();
            }
            open() {
              this.classList.add("is-active"),
                document.body.classList.add("scroll-lock");
            }
            close() {
              this.classList.remove("is-active"),
                document.body.classList.remove("scroll-lock");
            }
          }
        );
      },
      599: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(409);
        customElements.define(
          "social-media-gallery-slider",
          class extends HTMLElement {
            async connectedCallback() {
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Navigation: e } = await i.e(150).then(i.bind(i, 150));
              t.use([e]);
              const a = this.querySelector("[data-swiper]"),
                n = this.querySelector("[data-swiper-wrapper]");
              let r = this.querySelectorAll("[data-swiper-slide]"),
                o = r.length;
              if (o > 0) {
                const t = (0, s.x)() ? 10 : 6;
                if (o < t) {
                  const e = Array.from(r),
                    i = document.createDocumentFragment();
                  for (; i.childNodes.length + o < t; )
                    e.forEach((t) => {
                      const e = t.cloneNode(!0);
                      i.appendChild(e);
                    });
                  n.appendChild(i),
                    (r = this.querySelectorAll("[data-swiper-slide]")),
                    (o = r.length);
                }
              }
              this.swiper = new t(a, {
                loop: !0,
                navigation: !1,
                spaceBetween: 10,
                slidesPerView: 3,
                breakpoints: { 1024: { spaceBetween: 20, slidesPerView: 5 } },
                on: {
                  init: () => {
                    this.classList.remove("is-loading");
                  },
                },
              });
              const c = this.querySelector("[data-swiper-button-next]"),
                l = this.querySelector("[data-swiper-button-prev]");
              o <= 1 || ((0, s.x)() && o < 5)
                ? (c?.remove(), l?.remove())
                : (c?.addEventListener("click", () => this.swiper.slideNext()),
                  l?.addEventListener("click", () => this.swiper.slidePrev()));
            }
          }
        );
      },
      619: (t, e, i) => {
        "use strict";
        i.d(e, { A: () => a, m: () => s });
        const s = 1024,
          a = 16;
      },
      633: () => {
        customElements.define(
          "cart-line-item",
          class extends HTMLElement {
            connectedCallback() {
              (this.minusBtn = this.querySelector("[data-minus-btn]")),
                (this.plusBtn = this.querySelector("[data-plus-btn]")),
                (this.removeBtn = this.querySelector("[data-remove-btn]")),
                (this.productId = this.dataset.productId),
                (this.lineKey = this.dataset.key),
                (this.quantity = parseInt(this.dataset.quantity, 10)),
                this.minusBtn?.addEventListener("click", () =>
                  this.emitQuantity(this.quantity - 1)
                ),
                this.plusBtn?.addEventListener("click", () =>
                  this.emitQuantity(this.quantity + 1)
                ),
                this.removeBtn?.addEventListener("click", () =>
                  this.emitQuantity(0, Object.hasOwn(this.dataset, "hasAddOns"))
                );
            }
            emitQuantity(t, e = !1) {
              !this.lineKey ||
                Number.isNaN(t) ||
                t < 0 ||
                this.dispatchEvent(
                  new CustomEvent("cart-drawer:update", {
                    bubbles: !0,
                    detail: {
                      id: this.productId,
                      key: this.lineKey,
                      quantity: t,
                      removeAddOns: e,
                    },
                  })
                );
            }
          }
        );
      },
      658: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(409);
        customElements.define(
          "accordion-component",
          class extends HTMLElement {
            connectedCallback() {
              this.querySelector("[data-accordion-button]").addEventListener(
                "click",
                () => {
                  this.classList.toggle("is-active");
                  const t = () => {
                    const e = this.getBoundingClientRect();
                    if (
                      !(
                        e.top >= 0 &&
                        e.bottom <=
                          (window.innerHeight ||
                            document.documentElement.clientHeight)
                      )
                    ) {
                      const t = this.offsetTop;
                      window.scroll({ top: t, behavior: "smooth" });
                    }
                    this.removeEventListener("transitionend", t);
                  };
                  (0, s.x)() ||
                    this.addEventListener("transitionend", t, { once: !0 });
                }
              );
            }
          }
        );
      },
      684: (t, e, i) => {
        "use strict";
        var s = i(978),
          a = i(741);
        function n(t) {
          return t
            .normalize("NFD")
            .replace(/[\[\]'()"]+/g, "")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/([^\w]+|\s+)/g, "-")
            .replace(/\-\-+/g, "-")
            .replace(/(^-+|-+$)/g, "")
            .toLowerCase();
        }
        customElements.define(
          "product-form",
          class extends HTMLElement {
            connectedCallback() {
              (this.variantInput = this.querySelector("[data-variant-id]")),
                (this.optionSelectors = this.querySelectorAll(
                  "[data-product-options]"
                )),
                (this.productData = this.getProductData()),
                (this.variants = this.productData.variants || []),
                (this.submitBtn = this.querySelector("[data-atc-btn]")),
                (this.error = this.querySelector("[data-error]")),
                (this.priceEl = this.querySelector("[data-atc-btn-price]")),
                (this.assemblyInputs = this.querySelectorAll(
                  "input[data-assembly-product]"
                )),
                (this.upsellItemInputs = this.querySelectorAll(
                  "input[data-upsell-item]"
                )),
                [
                  ...this.assemblyInputs,
                  ...this.upsellItemInputs,
                ].forEach((t) => {
                  t.addEventListener("change", () => this.updateTotalPrice());
                }),
                this.optionSelectors.forEach((t) => {
                  t.addEventListener("change", () =>
                    (this.updateSelectedVariant((t) =>
                      this.dispatchEvent(
                        new CustomEvent("variant:change", {
                          bubbles: !0,
                          detail: { variant: t },
                        })
                      )
                    ),
                    this.updateTotalPrice())
                  );
                }),
                this.addEventListener("submit", this.onSubmit.bind(this)),
                this.selectFirstAvailableVariantIfNeeded(),
                this.updateSelectedVariant(),
                this.updateTotalPrice();
            }
            selectFirstAvailableVariantIfNeeded() {
              if (!this.optionSelectors.length || !this.variants.length) return;
              const t = Array.from(this.optionSelectors).map((t) => n(t.value)),
                e = this.variants.find((e) =>
                  t.every((t, i) => n(e.options[i]) === t)
                );
              if (e?.available) return;
              const i = this.variants.find((t) => t.available);
              i &&
                this.optionSelectors.forEach((t, e) => {
                  null != i.options[e] && (t.value = i.options[e]);
                });
            }
            getProductData() {
              const t = document.querySelector("script[data-product-data]");
              if (!t) return {};
              try {
                return JSON.parse(t.textContent);
              } catch (t) {
                return console.error("Failed to parse product JSON", t), {};
              }
            }
            updateSelectedVariant(t) {
              const e = Array.from(this.optionSelectors).map((t) => n(t.value)),
                i = new Set(
                  this.variants.map((t) => t.options.map(n).join("|"))
                );
              this.optionSelectors.forEach((t, s) => {
                const a = e.slice();
                Array.from(t.options).forEach((t) => {
                  a[s] = n(t.value);
                  const e = a.join("|");
                  t.disabled = !i.has(e);
                });
              });
              const s = this.variants.find((t) =>
                e.every((e, i) => n(t.options[i]) === e)
              );
              if ((t && t(s), s)) {
                (this.variantInput.value = s.id), (this.currentVariant = s);
                const t = new URL(window.location.href);
                t.searchParams.set("variant", s.id),
                  window.history.replaceState({}, "", t);
              } else
                (this.currentVariant = null),
                  console.warn("No matching variant for options:", e);
              s?.available && this.areBundleComponentsAvailable()
                ? ((this.submitBtn.disabled = !1),
                  this.submitBtn.classList.remove("is-disabled"))
                : ((this.submitBtn.disabled = !0),
                  this.submitBtn.classList.add("is-disabled"));
            }
            areBundleComponentsAvailable() {
              return Array.from(
                this.querySelectorAll("input[data-bundle-component-id]")
              )
                .filter((t) => !t.disabled)
                .every((t) => t.dataset.available == "true");
            }
            async onSubmit(t) {
              if ((t.preventDefault(), !this.currentVariant)) return;
              (this.error.textContent = ""), this.setLoading(!0);
              const e = [
                ...this.querySelectorAll(
                  "input[data-assembly-product]:checked"
                ),
                ...this.querySelectorAll(
                  "input[data-upsell-item]:checked"
                ),
              ];
              let mainProperties = { ...this.getBundleComponentProperties() };
              if (e.length > 0) {
                mainProperties._has_add_ons = !0;
              }
              i = [
                {
                  id: this.currentVariant.id,
                  quantity: 1,
                  properties: mainProperties,
                },
              ];
              e.forEach((t) => {
                i.push({
                  id: t.value,
                  quantity: 1,
                  properties: { _parent_id: this.productData.id },
                });
              });
              window.dispatchEvent(
                new CustomEvent("cart:add-items", {
                  detail: {
                    items: i,
                    errorEl: this.error,
                    successCallback: () => this.setLoading(!1),
                  },
                })
              );
            }
            getBundleComponentProperties() {
              let bundleComponentIds = [];
              const inputs = Array.from(
                this.querySelectorAll("input[data-bundle-component-id]")
              );
              if (inputs.length == 0) return null;
              inputs
                .filter((t) => !t.disabled)
                .forEach((t) => {
                  bundleComponentIds.push(t.value);
                });
              return { _bundleComponents: bundleComponentIds.join(",") };
            }
            setLoading(t) {
              this.submitBtn &&
                (t
                  ? (this.submitBtn.classList.add("is-loading"),
                    (this.submitBtn.disabled = !0))
                  : (this.submitBtn.classList.remove("is-loading"),
                    (this.submitBtn.disabled = !1)));
            }
            updateTotalPrice() {
              const t = this.currentVariant
                  ? this.currentVariant.price
                  : this.productData.price,
                e = [
                  ...this.querySelectorAll(
                    "input[data-assembly-product]:checked"
                  ),
                  ...this.querySelectorAll(
                    "input[data-upsell-item]:checked"
                  ),
                ];
              if (null == t) return;
              let i = t;
              e.forEach((t) => {
                const e = parseInt(t.dataset.price, 10) || 0;
                i += e;
              });
              const n = (t) =>
                (0, s.t)(
                  t,
                  `${
                    "GBP" === window.Shopify.currency.active
                      ? (0, a.Q)(window.Shopify.currency.active)
                      : ""
                  }{{amount}} ${window.Shopify.currency.active}`
                );
              this.priceEl && (this.priceEl.textContent = n(i));
              const r = document.querySelector(
                "[data-product-price] .font-semibold"
              );
              r && (r.textContent = n(t));
            }
          }
        );
      },
      724: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(619),
          a = i(735),
          n = i(409);
        customElements.define(
          "product-card",
          class extends HTMLElement {
            connectedCallback() {
              requestAnimationFrame(() => {
                (this.buttonOpenStateHeight = getComputedStyle(this)
                  .getPropertyValue("--button-open-state-height")
                  .trim()),
                  (this.imageContainer = this.querySelector(
                    "[data-image-container]"
                  )),
                  (this.content = this.querySelector("[data-content]")),
                  (this.innerContent = this.querySelector(
                    "[data-inner-content]"
                  )),
                  this.imageContainer &&
                    this.content &&
                    this.setInitialCSSVars();
              }),
                (this.updateLayout = this.updateLayout.bind(this)),
                window.addEventListener("collection-tab-change", () => {
                  this.updateLayout(), requestAnimationFrame(this.updateLayout);
                }),
                (0, n.x)() &&
                  ((this.handleResize = this.handleResize.bind(this)),
                  (this.debouncedResizeHandler = (0, a.s)(
                    this.handleResize,
                    200
                  )),
                  window.addEventListener(
                    "resize",
                    this.debouncedResizeHandler
                  ));
            }
            disconnectedCallback() {
              window.removeEventListener(
                "collection-tab-change",
                this.updateLayout
              ),
                (0, n.x)() &&
                  window.removeEventListener(
                    "resize",
                    this.debouncedResizeHandler
                  );
            }
            handleResize() {
              this.resetCSSVars(),
                clearTimeout(this._initTimeout),
                clearTimeout(this._setInitialFnTimeout),
                (this._setInitialFnTimeout = setTimeout(() => {
                  this.setInitialCSSVars();
                }, 50));
            }
            resetCSSVars() {
              this.style.removeProperty("--product-content-height"),
                this.style.removeProperty("--product-inner-content-height"),
                this.style.removeProperty(
                  "--product-inner-content-open-height"
                ),
                this.style.removeProperty("--product-image-height"),
                this.style.removeProperty("--product-card-client-height"),
                this.style.removeProperty("--product-card-offset-height"),
                this.classList.remove("is-init");
            }
            setInitialCSSVars() {
              const t = this.content.offsetHeight,
                e = this.innerContent.offsetHeight,
                i =
                  this.innerContent.offsetHeight +
                  parseFloat(this.buttonOpenStateHeight) * s.A,
                a = this.imageContainer.offsetHeight,
                n = this.clientHeight,
                r = this.offsetHeight;
              this.style.setProperty("--product-content-height", `${t}px`),
                this.style.setProperty(
                  "--product-inner-content-height",
                  `${e}px`
                ),
                this.style.setProperty(
                  "--product-inner-content-open-height",
                  `${i}px`
                ),
                this.style.setProperty("--product-image-height", `${a}px`),
                this.style.setProperty(
                  "--product-card-client-height",
                  `${n}px`
                ),
                this.style.setProperty(
                  "--product-card-offset-height",
                  `${r}px`
                ),
                clearTimeout(this._initTimeout),
                (this._initTimeout = setTimeout(() => {
                  this.classList.add("is-init");
                }, 300));
            }
            updateLayout() {
              this.resetCSSVars(), this.setInitialCSSVars();
            }
          }
        );
      },
      735: (t, e, i) => {
        "use strict";
        function s(t, e) {
          let i;
          return function (...s) {
            clearTimeout(i),
              (i = setTimeout(() => {
                (i = null), t(...s);
              }, e));
          };
        }
        i.d(e, { s: () => s });
      },
      741: (t, e, i) => {
        "use strict";
        function s(t, e = "en") {
          const i = new Intl.NumberFormat(e, {
            style: "currency",
            currency: t,
            currencyDisplay: "symbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })
            .formatToParts(0)
            .find((t) => "currency" === t.type);
          return i?.value || t;
        }
        i.d(e, { Q: () => s });
      },
      759: () => {
        customElements.define(
          "cart-line-item-wrapper",
          class extends HTMLElement {
            connectedCallback() {
              (this.toggleBtn = this.querySelector("[data-toggle-add-ons]")),
                this.toggleBtn &&
                  ((this._onToggleClick = this._onToggleClick.bind(this)),
                  this.toggleBtn.addEventListener(
                    "click",
                    this._onToggleClick
                  ));
            }
            disconnectedCallback() {
              this.toggleBtn?.removeEventListener("click", this._onToggleClick);
            }
            _onToggleClick() {
              this.classList.toggle("is-active");
            }
          }
        );
      },
      768: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(735),
          a = i(409);
        customElements.define(
          "product-media",
          class extends HTMLElement {
            connectedCallback() {
              (this.mainSlider = this.querySelector("[data-main-slider]")),
                (this.mainSlides = this.querySelectorAll("[data-main-image]")),
                (this.thumbnailSlider = this.querySelector(
                  "[data-thumbnail-slider]"
                )),
                (this.thumbnails = this.querySelectorAll("[data-thumbnail]")),
                (this.prevBtn = this.querySelector("[data-prev-button]")),
                (this.nextBtn = this.querySelector("[data-next-button]")),
                (this.overlayLeft = this.querySelector("[data-main-left]")),
                (this.overlayRight = this.querySelector("[data-main-right]")),
                (this.isDesktop = (0, a.x)()),
                (this.scrollByDirection = this.isDesktop ? "top" : "left"),
                (this.GAP = this.isDesktop ? 16 : 12),
                (this.thumbnailSize = this.isDesktop
                  ? this.thumbnails[0]?.getBoundingClientRect().height
                  : this.thumbnails[0]?.getBoundingClientRect().width),
                this.prevBtn?.addEventListener("click", this.scrollPrev),
                this.nextBtn?.addEventListener("click", this.scrollNext),
                this.thumbnails?.forEach((t, e) => {
                  t.addEventListener("click", () =>
                    this.handleThumbnailClick(t, e)
                  );
                }),
                (this.debouncedHandleMainSliderScroll = (0, s.s)(
                  this.handleMainSliderScroll,
                  50
                )),
                this.mainSlider?.addEventListener(
                  "scroll",
                  this.debouncedHandleMainSliderScroll
                ),
                this.overlayLeft?.addEventListener(
                  "click",
                  this.handleMainLeftClick
                ),
                this.overlayRight?.addEventListener(
                  "click",
                  this.handleMainRightClick
                );
            }
            scrollPrev = () => {
              this.thumbnailSlider.scrollBy({
                [this.scrollByDirection]: -this.thumbnailSize - this.GAP,
                behavior: "smooth",
              });
            };
            scrollNext = () => {
              this.thumbnailSlider.scrollBy({
                [this.scrollByDirection]: this.thumbnailSize + this.GAP,
                behavior: "smooth",
              });
            };
            handleThumbnailClick(t, e) {
              this.thumbnails.forEach((t) => t.classList.remove("is-active")),
                t.classList.add("is-active");
              const i = this.mainSlides[e];
              if (i) {
                const t = i.offsetLeft - this.mainSlider.offsetLeft;
                this.mainSlider.scrollTo({ left: t, behavior: "smooth" });
              }
            }
            handleMainSliderScroll = () => {
              const t = this.mainSlider.getBoundingClientRect();
              let e = 0,
                i = 0;
              this.mainSlides.forEach((s, a) => {
                const n = s.getBoundingClientRect(),
                  r =
                    (Math.min(n.right, t.right) - Math.max(n.left, t.left)) /
                    n.width;
                r > i && ((i = r), (e = a));
              }),
                this.thumbnails.forEach((t, i) => {
                  t.classList.toggle("is-active", i === e);
                });
              const s = this.thumbnails[e];
              if (!s) return;
              const a = this.thumbnailSlider.getBoundingClientRect(),
                n = s.getBoundingClientRect();
              this.isDesktop
                ? n.top < a.top
                  ? this.thumbnailSlider.scrollBy({
                      top: n.top - a.top - this.GAP,
                      behavior: "smooth",
                    })
                  : n.bottom > a.bottom &&
                    this.thumbnailSlider.scrollBy({
                      top: n.bottom - a.bottom + this.GAP,
                      behavior: "smooth",
                    })
                : n.left < a.left
                ? this.thumbnailSlider.scrollBy({
                    left: n.left - a.left - this.GAP,
                    behavior: "smooth",
                  })
                : n.right > a.right &&
                  this.thumbnailSlider.scrollBy({
                    left: n.right - a.right + this.GAP,
                    behavior: "smooth",
                  });
            };
            handleMainLeftClick = () => {
              const t = this.mainSlider.scrollLeft,
                e = this.findClosestSlideIndex(t),
                i = Math.max(0, e - 1);
              this.scrollToSlide(i);
            };
            handleMainRightClick = () => {
              const t = this.mainSlider.scrollLeft,
                e = this.findClosestSlideIndex(t),
                i = Math.min(this.mainSlides.length - 1, e + 1);
              this.scrollToSlide(i);
            };
            findClosestSlideIndex(t) {
              let e = 0,
                i = 1 / 0;
              return (
                this.mainSlides.forEach((s, a) => {
                  const n = s.offsetLeft,
                    r = Math.abs(t - n);
                  r < i && ((i = r), (e = a));
                }),
                e
              );
            }
            scrollToSlide(t) {
              const e = this.mainSlides[t];
              if (e) {
                const t = e.offsetLeft - this.mainSlider.offsetLeft;
                this.mainSlider.scrollTo({ left: t, behavior: "smooth" });
              }
            }
          }
        );
      },
      793: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(409);
        customElements.define(
          "featured-testimonials-slider",
          class extends HTMLElement {
            async connectedCallback() {
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Navigation: e, Pagination: a } = await i
                  .e(150)
                  .then(i.bind(i, 150));
              t.use([e, a]);
              const n = this.querySelector("[data-swiper]"),
                r = this.querySelector("[data-swiper-wrapper]");
              let o = this.querySelectorAll("[data-swiper-slide]"),
                c = o.length;
              if (c > 0) {
                const t = (0, s.x)() ? 8 : 2;
                if (c < t) {
                  const e = t - c,
                    i = Array.from(o),
                    s = document.createDocumentFragment();
                  for (let t = 0; t < e; t++) {
                    const e = i[t % c].cloneNode(!0);
                    s.appendChild(e);
                  }
                  r.appendChild(s),
                    (o = this.querySelectorAll("[data-swiper-slide]")),
                    (c = o.length);
                }
              }
              this.swiper = new t(n, {
                loop: !0,
                navigation: !1,
                initialSlide: Math.floor((c - 1) / 2),
                breakpoints: {
                  1024: {
                    watchSlidesProgress: !0,
                    slidesPerView: 4,
                    spaceBetween: 32,
                    centeredSlides: !0,
                    slideFullyVisibleClass: "is-visible",
                  },
                },
                pagination: {
                  el: "[data-swiper-pagination]",
                  dynamicBullets: !0,
                  bulletElement: "button",
                  bulletClass: "slider-bullet-dark",
                  bulletActiveClass: "slider-bullet-dark-active",
                },
              });
              const l = this.querySelector("[data-swiper-button-next]"),
                d = this.querySelector("[data-swiper-button-prev]");
              c <= 1 || ((0, s.x)() && c < 5)
                ? (l?.remove(), d?.remove())
                : (l?.addEventListener("click", () => this.swiper.slideNext()),
                  d?.addEventListener("click", () => this.swiper.slidePrev()));
            }
          }
        );
      },
      799: (t, e, i) => {
        customElements.define(
          "upsell-slider",
          class extends HTMLElement {
            async connectedCallback() {
              const { default: t } = await i.e(236).then(i.bind(i, 236)),
                { Navigation: e, Pagination: s } = await i
                  .e(150)
                  .then(i.bind(i, 150));
              t.use([e, s]);
              const a = this.querySelector("[data-swiper]"),
                n = this.querySelectorAll("[data-swiper-slide]").length,
                r = Object.hasOwn(this.dataset, "loop");
              if (n <= 1) return;
              this.swiper = new t(a, {
                loop: r,
                navigation: !1,
                slidesPerView: 1,
                breakpoints: { 1024: { slidesPerView: 1.2 } },
                pagination: {
                  el: "[data-swiper-pagination]",
                  dynamicBullets: !0,
                  bulletElement: "span",
                  bulletClass: "slider-bullet-dark",
                  bulletActiveClass: "slider-bullet-dark-active",
                },
              });
              const o = this.querySelector("[data-swiper-button-next]"),
                c = this.querySelector("[data-swiper-button-prev]");
              n <= 1
                ? (o?.remove(), c?.remove())
                : (o?.addEventListener("click", () => this.swiper.slideNext()),
                  c?.addEventListener("click", () => this.swiper.slidePrev()));
            }
          }
        );
      },
      801: () => {
        customElements.define(
          "selectable-product-card",
          class extends HTMLElement {
            connectedCallback() {
              (this.checkbox = this.querySelector("[data-checkbox]")),
                this.checkbox &&
                  ((this.handleClick = this.handleClick.bind(this)),
                  this.addEventListener("click", this.handleClick),
                  this.querySelectorAll("a").forEach((t) => {
                    t.addEventListener("click", (t) => t.stopPropagation());
                  }));
            }
            disconnectedCallback() {
              this.removeEventListener("click", this.handleClick);
            }
            handleClick() {
              (this.checkbox.checked = !this.checkbox.checked),
                this.checkbox.dispatchEvent(
                  new Event("change", { bubbles: !0 })
                );
            }
          }
        );
      },
      814: () => {
        customElements.define(
          "cart-main",
          class extends HTMLElement {
            connectedCallback() {
              (this.sectionId = this.dataset.sectionId),
                (this.cartDrawer = this.closest("cart-drawer")),
                this._bindEvents();
            }
            disconnectedCallback() {
              this._unbindEvents();
            }
            _bindEvents() {
              (this._onCartUpdate = this._onCartUpdate.bind(this)),
                (this._onAddItems = this._onAddItems.bind(this)),
                this.addEventListener("cart-drawer:update", this._onCartUpdate),
                window.addEventListener("cart:add-items", this._onAddItems);
            }
            _unbindEvents() {
              this.removeEventListener(
                "cart-drawer:update",
                this._onCartUpdate
              ),
                window.removeEventListener("cart:add-items", this._onAddItems);
            }
            async _cartSectionHtml(t) {
              const e = t?.sections?.[this.sectionId];
              if (e) return e;
              try {
                const i = await fetch(
                  `/?sections=${encodeURIComponent(this.sectionId)}`
                );
                if (!i.ok) return;
                const s = await i.json();
                return s?.[this.sectionId];
              } catch (t) {
                return;
              }
            }
            async _onCartUpdate(t) {
              const { id: e, key: i, quantity: s, removeAddOns: a } = t.detail;
              this.cartDrawer?.classList.add("is-loading"),
                this.classList.add("is-loading");
              const n = JSON.parse(
                  this.querySelector("[data-cart-data]").textContent
                ),
                r = { [i]: s };
              a &&
                n.items
                  .filter((t) => t.properties._parent_id?.toString() === e)
                  .map((t) => t.key)
                  .forEach((t) => {
                    r[t] = 0;
                  });
              try {
                const t = await fetch("/cart/update.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      updates: r,
                      sections: [this.sectionId],
                    }),
                  }),
                  e = await t.json();
                await this._updateCartDrawerFromHTML(
                  await this._cartSectionHtml(e)
                );
              } catch (t) {
                console.error("Cart update error:", t);
              } finally {
                this.cartDrawer?.classList.remove("is-loading"),
                  this.classList.remove("is-loading");
              }
            }
            async _onAddItems(t) {
              const { items: e, errorEl: i, successCallback: s } = t.detail;
              this.cartDrawer?.classList.add("is-loading"),
                this.classList.add("is-loading");
              try {
                const t = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      items: e,
                      sections: [this.sectionId],
                    }),
                  }),
                  i = await t.json();
                if (!t.ok) throw new Error(i.description || i.message);
                await this._updateCartDrawerFromHTML(
                  await this._cartSectionHtml(i)
                );
              } catch (t) {
                i && (i.textContent = t.message),
                  console.error("Cart add error:", t);
              } finally {
                this.cartDrawer?.classList.remove("is-loading"),
                  this.classList.remove("is-loading"),
                  s && s();
              }
            }
            async _updateCartDrawerFromHTML(t) {
              if (!t) return;
              const e = new DOMParser().parseFromString(t, "text/html"),
                i = e.querySelector("[data-cart-content]"),
                s = this.querySelector("[data-cart-content]");
              i &&
                s &&
                ((s.innerHTML = i.innerHTML),
                (this.closeBtn = this.querySelector("[data-close-btn]")),
                this.closeBtn?.addEventListener("click", () => this.close()));
              const a = JSON.parse(
                  e.querySelector("[data-cart-data]").textContent
                ),
                n = e.querySelector("script[data-cart-gift-data]");
              if (n)
                try {
                  const { is_eligible: t, gift_id: e } = JSON.parse(
                      n.textContent
                    ),
                    i = a.items.find(
                      (t) => t.variant_id === e && t.properties?._is_gift
                    );
                  if (t && e && !i) return void (await this._addGiftProduct(e));
                  if (!t && i)
                    return void (await this._removeGiftProduct(i.key));
                } catch (t) {
                  console.warn("Failed to handle gift logic:", t);
                }
              window.dispatchEvent(
                new CustomEvent("cart-items-count:update", {
                  bubbles: !0,
                  detail: { quantity: a.item_count },
                })
              ),
                this.open();
            }
            async _addGiftProduct(t) {
              const e = await fetch("/cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    id: t,
                    quantity: 1,
                    properties: { _is_gift: !0 },
                    sections: [this.sectionId],
                  }),
                }),
                i = await e.json();
              if (!e.ok) throw new Error(i.description || i.message);
              await this._updateCartDrawerFromHTML(await this._cartSectionHtml(i));
            }
            async _removeGiftProduct(t) {
              const e = await fetch("/cart/update.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    updates: { [t]: 0 },
                    sections: [this.sectionId],
                  }),
                }),
                i = await e.json();
              if (!e.ok) throw new Error(i.description || i.message);
              await this._updateCartDrawerFromHTML(await this._cartSectionHtml(i));
            }
            open() {
              const t = this.closest("cart-drawer");
              t && t.open();
            }
            close() {
              const t = this.closest("cart-drawer");
              t && t.close();
            }
          }
        );
      },
      836: () => {
        "use strict";
        customElements.define(
          "product-recommendations",
          class extends HTMLElement {
            connectedCallback() {
              (this.observer = new IntersectionObserver(
                async ([t], e) => {
                  if (!t.isIntersecting) return;
                  e.unobserve(this);
                  const { url: i } = this.dataset;
                  if (i)
                    try {
                      const t = await (async (t) =>
                          fetch(t)
                            .then((t) => {
                              if (!t.ok) throw new Error(t.statusText);
                              return t.text();
                            })
                            .then((t) =>
                              new DOMParser().parseFromString(t, "text/html")
                            ))(i),
                        e = t.querySelector("product-recommendations");
                      e ? (this.innerHTML = e.innerHTML) : this.remove();
                    } catch (t) {
                      this.remove(),
                        console.error(
                          "Failed to fetch product recommendations:",
                          t
                        );
                    }
                },
                { rootMargin: "0px 0px 200px 0px" }
              )),
                this.observer.observe(this);
            }
            disconnectedCallback() {
              this.observer?.disconnect();
            }
          }
        );
      },
      844: (t, e, i) => {
        "use strict";
        i.r(e);
        var s = i(978),
          a = i(741);
        customElements.define(
          "frequently-bought-form",
          class extends HTMLElement {
            connectedCallback() {
              (this.checkboxes = this.querySelectorAll("[data-checkbox]")),
                (this.totalPriceEl = this.querySelector("[data-total-price]")),
                (this.submitButton = this.querySelector("[data-submit-btn]")),
                (this.error = this.querySelector("[data-error]")),
                (this.onChange = this.onChange.bind(this)),
                (this.onSubmit = this.onSubmit.bind(this)),
                this.checkboxes.forEach((t) =>
                  t.addEventListener("change", this.onChange)
                ),
                this.submitButton?.addEventListener("click", this.onSubmit);
            }
            getVariantData(t) {
              const e = t
                .closest("selectable-product-card")
                ?.querySelector("script[data-variant-json]");
              if (!e) return null;
              try {
                return JSON.parse(e.textContent);
              } catch (t) {
                return console.error("Invalid variant JSON:", t), null;
              }
            }
            onChange() {
              let t = 0,
                e = 0;
              this.checkboxes.forEach((i) => {
                if (!i.checked) return;
                const s = this.getVariantData(i);
                s && ((t += s.price || 0), e++);
              }),
                (this.totalPriceEl.textContent = (0, s.t)(
                  t,
                  `${(0, a.Q)(this.dataset.currency)}{{amount}} ${
                    this.dataset.currency
                  }`
                )),
                e > 0
                  ? this.submitButton.removeAttribute("disabled")
                  : this.submitButton.setAttribute("disabled", "");
            }
            async onSubmit(t) {
              t.preventDefault(), this.submitButton.classList.add("is-loading");
              const e = Array.from(this.checkboxes)
                .filter((t) => t.checked)
                .map((t) => {
                  const e = this.getVariantData(t);
                  return e ? { id: e.id, quantity: 1 } : null;
                })
                .filter(Boolean);
              e.length &&
                window.dispatchEvent(
                  new CustomEvent("cart:add-items", {
                    detail: {
                      items: e,
                      errorEl: this.error,
                      successCallback: () =>
                        this.submitButton.classList.remove("is-loading"),
                    },
                  })
                );
            }
          }
        );
      },
      853: () => {
        customElements.define(
          "logo-slider",
          class extends HTMLElement {
            constructor() {
              super(),
                (this.speed = 0.5),
                (this.position = 0),
                (this.isPaused = !1),
                (this.isDragging = !1),
                (this.startX = 0),
                (this.startPosition = 0),
                (this._dragged = !1),
                (this._onDragStart = this._onDragStart.bind(this)),
                (this._onDragMove = this._onDragMove.bind(this)),
                (this._onDragEnd = this._onDragEnd.bind(this)),
                (this._tick = this._tick.bind(this));
            }
            connectedCallback() {
              if (
                ((this.track = this.querySelector("[data-track]")), !this.track)
              )
                return;
              this.track.innerHTML =
                this.track.innerHTML +
                this.track.innerHTML +
                this.track.innerHTML;
              const t = parseFloat(
                getComputedStyle(this).getPropertyValue("--animation-duration")
              );
              if (!Number.isNaN(t) && t > 0) {
                const e = this.track.scrollWidth / 3;
                (this.speed = e / (60 * t)), (this._trackWidth = e);
              }
              this.addEventListener("mouseenter", () => (this.isPaused = !0)),
                this.addEventListener("mouseleave", () => (this.isPaused = !1)),
                this.addEventListener("mousedown", this._onDragStart),
                this.addEventListener("mousemove", this._onDragMove),
                this.addEventListener("mouseup", this._onDragEnd),
                this.addEventListener("mouseleave", this._onDragEnd),
                this.addEventListener("touchstart", this._onDragStart, {
                  passive: !0,
                }),
                this.addEventListener("touchmove", this._onDragMove, {
                  passive: !1,
                }),
                this.addEventListener("touchend", this._onDragEnd),
                this.addEventListener("click", (t) => {
                  this._dragged &&
                    (t.preventDefault(), t.stopImmediatePropagation());
                }),
                requestAnimationFrame(this._tick);
            }
            disconnectedCallback() {
              cancelAnimationFrame(this._raf);
            }
            _tick() {
              this.isPaused || this.isDragging || (this.position -= this.speed);
              const t = this._trackWidth;
              this.position <= -t
                ? (this.position += t)
                : this.position >= 0 && (this.position -= t),
                (this.track.style.transform = `translateX(${this.position}px)`),
                (this._raf = requestAnimationFrame(this._tick));
            }
            _onDragStart(t) {
              (this.isDragging = !0),
                (this.isPaused = !0),
                (this.startX = t.type.includes("mouse")
                  ? t.pageX
                  : t.touches[0].pageX),
                (this.startPosition = this.position);
            }
            _onDragMove(t) {
              if (!this.isDragging) return;
              t.preventDefault();
              const e =
                (t.type.includes("mouse") ? t.pageX : t.touches[0].pageX) -
                this.startX;
              this.position = this.startPosition + e;
              const i = this._trackWidth;
              this.position <= -i
                ? (this.position += i)
                : this.position >= 0 && (this.position -= i),
                (this.track.style.transform = `translateX(${this.position}px)`);
            }
            _onDragEnd() {
              (this.isDragging = !1),
                (this.isPaused = !1),
                (this._dragged =
                  Math.abs(this.position - this.startPosition) > 5);
            }
          }
        );
      },
      978: (t, e, i) => {
        "use strict";
        function s(t, e) {
          function i(t, e = 2, i = ",", s = ".") {
            if (Number.isNaN(t) || null == t) return "0";
            const a = (t / 100).toFixed(e).split(".");
            return (
              a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) +
              (a[1] ? s + a[1] : "")
            );
          }
          return e.replace(/{{\s*(\w+)\s*}}/, (e, s) => {
            switch (s) {
              case "amount":
                return i(t, 2);
              case "amount_no_decimals":
                return i(t, 0);
              case "amount_with_comma_separator":
                return i(t, 2, ".", ",");
              case "amount_no_decimals_with_comma_separator":
                return i(t, 0, ".", ",");
              case "amount_with_apostrophe_separator":
                return i(t, 2, "'", ".");
              case "amount_no_decimals_with_space_separator":
                return i(t, 0, " ");
              case "amount_with_space_separator":
                return i(t, 2, " ", ",");
              case "amount_with_period_and_space_separator":
                return i(t, 2, " ", ".");
              default:
                return e;
            }
          });
        }
        i.d(e, { t: () => s });
      },
      993: () => {
        customElements.define(
          "collection-tabs",
          class extends HTMLElement {
            connectedCallback() {
              this.initTabs();
            }
            initTabs() {
              const t = this.querySelectorAll("button[data-tab]"),
                e = this.querySelectorAll("product-slider");
              t.forEach((i) => {
                i.addEventListener("click", () => {
                  const s = i.getAttribute("data-tab");
                  t.forEach((t) => t.classList.remove("is-active")),
                    i.classList.add("is-active"),
                    e.forEach((t) => t.classList.remove("is-active"));
                  const a = this.querySelector(
                    `product-slider[data-slider="${s}"]`
                  );
                  a && a.classList.add("is-active"),
                    i.scrollIntoView({
                      behavior: "smooth",
                      inline: "center",
                      block: "nearest",
                    }),
                    window.dispatchEvent(
                      new CustomEvent("collection-tab-change")
                    );
                });
              });
            }
          }
        );
      },
    },
    n = {};
  function r(t) {
    var e = n[t];
    if (void 0 !== e) return e.exports;
    var i = (n[t] = { exports: {} });
    return a[t](i, i.exports, r), i.exports;
  }
  (r.m = a),
    (e = Object.getPrototypeOf
      ? (t) => Object.getPrototypeOf(t)
      : (t) => t.__proto__),
    (r.t = function (i, s) {
      if ((1 & s && (i = this(i)), 8 & s)) return i;
      if ("object" == typeof i && i) {
        if (4 & s && i.__esModule) return i;
        if (16 & s && "function" == typeof i.then) return i;
      }
      var a = Object.create(null);
      r.r(a);
      var n = {};
      t = t || [null, e({}), e([]), e(e)];
      for (var o = 2 & s && i; "object" == typeof o && !~t.indexOf(o); o = e(o))
        Object.getOwnPropertyNames(o).forEach((t) => (n[t] = () => i[t]));
      return (n.default = () => i), r.d(a, n), a;
    }),
    (r.d = (t, e) => {
      for (var i in e)
        r.o(e, i) &&
          !r.o(t, i) &&
          Object.defineProperty(t, i, { enumerable: !0, get: e[i] });
    }),
    (r.f = {}),
    (r.e = (t) =>
      Promise.all(Object.keys(r.f).reduce((e, i) => (r.f[i](t, e), e), []))),
    (r.u = (t) => t + ".js"),
    (r.miniCssF = (t) => {}),
    (r.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    })()),
    (r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
    (i = {}),
    (s = "golfbays:"),
    (r.l = (t, e, a, n) => {
      if (i[t]) i[t].push(e);
      else {
        var o, c;
        if (void 0 !== a)
          for (
            var l = document.getElementsByTagName("script"), d = 0;
            d < l.length;
            d++
          ) {
            var h = l[d];
            if (
              h.getAttribute("src") == t ||
              h.getAttribute("data-webpack") == s + a
            ) {
              o = h;
              break;
            }
          }
        o ||
          ((c = !0),
          ((o = document.createElement("script")).charset = "utf-8"),
          (o.timeout = 120),
          r.nc && o.setAttribute("nonce", r.nc),
          o.setAttribute("data-webpack", s + a),
          (o.src = t)),
          (i[t] = [e]);
        var u = (e, s) => {
            (o.onerror = o.onload = null), clearTimeout(m);
            var a = i[t];
            if (
              (delete i[t],
              o.parentNode && o.parentNode.removeChild(o),
              a && a.forEach((t) => t(s)),
              e)
            )
              return e(s);
          },
          m = setTimeout(
            u.bind(null, void 0, { type: "timeout", target: o }),
            12e4
          );
        (o.onerror = u.bind(null, o.onerror)),
          (o.onload = u.bind(null, o.onload)),
          c && document.head.appendChild(o);
      }
    }),
    (r.r = (t) => {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(t, "__esModule", { value: !0 });
    }),
    (() => {
      var t;
      r.g.importScripts && (t = r.g.location + "");
      var e = r.g.document;
      if (
        !t &&
        e &&
        (e.currentScript &&
          "SCRIPT" === e.currentScript.tagName.toUpperCase() &&
          (t = e.currentScript.src),
        !t)
      ) {
        var i = e.getElementsByTagName("script");
        if (i.length)
          for (var s = i.length - 1; s > -1 && (!t || !/^http(s?):/.test(t)); )
            t = i[s--].src;
      }
      if (!t)
        throw new Error(
          "Automatic publicPath is not supported in this browser"
        );
      (t = t
        .replace(/^blob:/, "")
        .replace(/#.*$/, "")
        .replace(/\?.*$/, "")
        .replace(/\/[^\/]+$/, "/")),
        (r.p = t);
    })(),
    (() => {
      var t = { 792: 0 };
      r.f.j = (e, i) => {
        var s = r.o(t, e) ? t[e] : void 0;
        if (0 !== s)
          if (s) i.push(s[2]);
          else {
            var a = new Promise((i, a) => (s = t[e] = [i, a]));
            i.push((s[2] = a));
            var n = r.p + r.u(e),
              o = new Error();
            r.l(
              n,
              (i) => {
                if (r.o(t, e) && (0 !== (s = t[e]) && (t[e] = void 0), s)) {
                  var a = i && ("load" === i.type ? "missing" : i.type),
                    n = i && i.target && i.target.src;
                  (o.message =
                    "Loading chunk " + e + " failed.\n(" + a + ": " + n + ")"),
                    (o.name = "ChunkLoadError"),
                    (o.type = a),
                    (o.request = n),
                    s[1](o);
                }
              },
              "chunk-" + e,
              e
            );
          }
      };
      var e = (e, i) => {
          var s,
            a,
            [n, o, c] = i,
            l = 0;
          if (n.some((e) => 0 !== t[e])) {
            for (s in o) r.o(o, s) && (r.m[s] = o[s]);
            c && c(r);
          }
          for (e && e(i); l < n.length; l++)
            (a = n[l]), r.o(t, a) && t[a] && t[a][0](), (t[a] = 0);
        },
        i = (self.webpackChunkgolfbays = self.webpackChunkgolfbays || []);
      i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
    })(),
    r(5)
      .keys()
      .forEach((t) => {
        r(322)(`./${t.replace("./", "")}`);
      });
})();
